module.exports = __webpack_public_path__ + "static/assets/da591ec3c9be987c218dbe9dfd7336f7.svg";